import { Typography } from '@prenuvo/halo';

import { ACTIVITY_LOG_ACTION } from '@/api';
import { isNotEmpty } from '@/shared/util';

import { ACTION_CLASSES, ActionClass } from '../activity-log.constant';
import { formatValue, shouldRenderArrow } from '../activity-log.util';

interface CustomNormalsProps {
  action: ActionClass;
  customNormalsObject: null | Record<string, string>;
  item: string;
  oldValue?: null | Record<string, string>;
}

export function CustomNormals({
  action,
  customNormalsObject,
  item,
  oldValue = null,
}: CustomNormalsProps) {
  const getActionClassName = (className: ActionClass) => ACTION_CLASSES[className] || '';

  if (!customNormalsObject && !oldValue) {
    return null;
  }

  const oldEntries = oldValue ? Object.entries(oldValue) : [];
  const newEntries = customNormalsObject ? Object.entries(customNormalsObject) : [];

  return (
    <div className="pb-2">
      <Typography
        className="pb-2"
        translationKey="FCT.ACTIVITY_LOG.CUSTOM_NORMALS.ITEM"
        values={{ item }}
        variant="paragraph-sm"
      />
      <div className="flex">
        {isNotEmpty(oldEntries) && (
          <ol className="ml-4 list-disc">
            {oldEntries.map(([key, normalsItem]) => (
              <li
                key={`old-${key}`}
                className={`marker:${getActionClassName(ACTIVITY_LOG_ACTION.DELETE)}`}
              >
                <Typography
                  as="label"
                  className={getActionClassName(ACTIVITY_LOG_ACTION.DELETE)}
                  translationKey="FCT.ACTIVITY_LOG.CUSTOM_NORMALS.OLD_VALUE"
                  values={{ oldValue: formatValue(normalsItem) }}
                  variant="paragraph-sm"
                />
              </li>
            ))}
          </ol>
        )}

        {shouldRenderArrow(
          isNotEmpty(newEntries) ? newEntries.length : null,
          isNotEmpty(oldEntries) ? oldEntries.length : null,
        ) && (
          <span className="mx-2 mt-1 leading-none" data-testid="arrow-seperator">
            &gt;
          </span>
        )}

        {isNotEmpty(newEntries) && (
          <ol className="ml-4 list-disc">
            {newEntries.map(([key, normalsItem]) => (
              <li key={`new-${key}`} className={`marker:${getActionClassName(action)}`}>
                <Typography
                  className={getActionClassName(action)}
                  translationKey="FCT.ACTIVITY_LOG.CUSTOM_NORMALS.VALUE"
                  values={{ value: formatValue(normalsItem) }}
                  variant="paragraph-sm"
                />
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
